const data = {
  id: 1,
  title: 'Listen and find the missing letters.',
  subTitle: 'Nghe và điền vào chỗ trống.',
  question: 'house',
  filterVowels: true,
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/357d67fc-09b7-4d30-95c9-ec09a4580d40.mp3',
};

export default data;
